import { useCreateGuest, getGuestsKey } from 'api-hooks/guest';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import { PreviousNavigation } from 'common/helpers/previous-navigation';
import { queryClient } from 'common/repositories/query-client';
import notification from 'components/common/notification';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useNavigation from 'hooks/use-navigation';
import { SeparatorVertical } from 'legacy-modules/styles';
import * as React from 'react';
import { NavigationProps } from 'types';

import GuestForm from './components/form';

export type GuestCreateParams = null;

export default function GuestCreate(
  props: NavigationProps<NavigationRoutes.GuestsCreate>,
) {
  const { navigate, back } = useNavigation();

  const { mutateAsync, error } = useCreateGuest();
  const permission = useGetCrudPermission('guests');
  return (
    <>
      {!!error && !!error.message && (
        <>
          <Notification
            overrides={{
              Body: { style: { width: 'auto', wordBreak: 'break-all' } },
            }}
            kind={KIND.negative}
            closeable
          >
            {() => error.message}
          </Notification>
          <SeparatorVertical $margin={8} />
        </>
      )}
      <GuestForm
        {...props}
        onSubmit={async (input, form) => {
          const result = await mutateAsync(input);

          queryClient.refetchQueries([getGuestsKey()[0]]);

          const prevPath = PreviousNavigation.get();
          if (prevPath) {
            PreviousNavigation.remove();
            back();
          } else if (permission.view) {
            navigate(NavigationRoutes.GuestsView, {
              id: result.data?.id,
            });
          }

          notification.success({ message: result?.message });

          return result.data;
        }}
      />
    </>
  );
}
